import Aos from 'aos';
import React from 'react';
import './App.css';
import { About } from './Components/About/About';
import { Github } from './Components/About/Github';
import { Contact } from './Components/Contact/Contact';
import { Header } from './Components/Header/Header';
import { Projects } from './Components/Projects/Projects';
import { ScrollToTop } from './Components/ScrollToTop/ScrollToTop';
import { ThemeContext } from './Context/theme';

function App() {
  const [{ themename }] = React.useContext(ThemeContext);
  React.useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);
  return (
    <>
      <div id="top" className={`${themename} app`}>
        <section id="#home">
          <Header />
        </section>
        <main>
          <About />
          <Github />
          <section id="#projects">
            <Projects />
          </section>
          <section id="#contact">
            <Contact />
          </section>
        </main>
        <ScrollToTop />
      </div>
    </>
  );
}

export default App;
